// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Oli8b","actions":"Form_actions__3oUrd","box":"Form_box__hnxHo"};